export default {
  "base": "max-w-[var(--ui-container)] mx-auto px-4 sm:px-6 lg:px-8"
}